import React from "react";
import ContactInfo from "../components/ContactInfo";

const Contact = () => {
  return (
    <section className="bg-white py-20 px-4 sm:px-6 lg:px-20">
      <div className="max-w-5xl mx-auto space-y-12">
        {/* Title & Subtitle */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-green-700 mb-4">
            Contact Us
          </h2>
          <p className="text-gray-600 text-md max-w-xl mx-auto">
            Have a question or want to connect? We'd love to hear from you.
          </p>
        </div>

        {/* Form & Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          {/* Contact Form */}
          <form className="bg-green-50 p-8 rounded-2xl shadow space-y-6 border border-green-100">
            <div>
              <label className="block text-gray-700 font-medium mb-1">Name</label>
              <input
                type="text"
                placeholder="Your full name"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Email</label>
              <input
                type="email"
                placeholder="you@example.com"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Message</label>
              <textarea
                rows="5"
                placeholder="Type your message here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
              ></textarea>
            </div>
            <div className="text-center">
              <button
                type="submit"
                className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-8 rounded-lg transition duration-300"
              >
                Send Message
              </button>
            </div>
          </form>

          {/* Static Contact Info (Phone, Address, etc.) */}
          <ContactInfo />
        </div>
      </div>
    </section>
  );
};

export default Contact;
